const AnalyticsModule = () => import('@/modules/AnalyticsModule')

export default [
	{
		component: AnalyticsModule,
		name: 'analytics',
		path: 'analytics'
	}
]
